import { useQuery } from '@tanstack/react-query';

import { createClient } from 'contentful';

import { getConfig } from '../../../utils/getConfig.js';
import { SidebarUpdateSkeleton } from '../components/UpdatesList/types.js';

const client = createClient({
  space: getConfig('CONTENTFUL_SPACE_ID'),
  accessToken: getConfig('CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN'),
});

async function getEntries() {
  const entryItems = await client.getEntries<SidebarUpdateSkeleton>({
    content_type: 'sidebarUpdate',
    order: ['-fields.isPinned'],
  });

  return entryItems.items;
}

export function useSidebarUpdates() {
  const { data, isLoading, isError } = useQuery(['sidebarUpdates'], getEntries);

  return { updates: data, isLoading, isError };
}
